export function Container({ className = "", children }) {
  return <div className={`mx-auto w-full max-w-container px-6 md:px-12 ${className}`}>{children}</div>;
}

export function SectionLabel({ children }) {
  return (
    <div className="mb-6 flex items-center gap-3">
      <span className="h-1.5 w-1.5 rounded-full bg-green" />
      <span className="text-xs font-medium uppercase tracking-[0.2em] text-black/50">{children}</span>
    </div>
  );
}
